'use strict';

var Mixin = require('../../utils/mixin'),
    inherits = require('util').inherits;

var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
  Mixin.call(this, stack);
  this.onItemPop = options.onItemPop;
};

inherits(LocationInfoOpenElementStackMixin, Mixin);

LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
  return {
    pop: function pop() {
      mxn.onItemPop(this.current);
      orig.pop.call(this);
    },
    popAllUpToHtmlElement: function popAllUpToHtmlElement() {
      for (var i = this.stackTop; i > 0; i--) {
        mxn.onItemPop(this.items[i]);
      }

      orig.popAllUpToHtmlElement.call(this);
    },
    remove: function remove(element) {
      mxn.onItemPop(this.current);
      orig.remove.call(this, element);
    }
  };
};